<div class="sheet-wrap">
  <header class="sheet-header">
    <div class="title">
      <mat-icon>polymer</mat-icon>
      <span>{{ translationService.getResinBreakdownText() }}</span>
    </div>
    <button mat-icon-button aria-label="Close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="meta">
    <div class="item">
      <span class="label">{{ translationService.getProductText() }}:</span
      ><span class="value">{{ data.productName }} ({{ data.sku }})</span>
    </div>
  </div>

  <div class="table-wrap mat-elevation-z1">
    <table
      mat-table
      [dataSource]="data.plasticResins"
      class="resin-table dense"
    >
      <ng-container matColumnDef="resinType">
        <th mat-header-cell *matHeaderCellDef class="sticky">
          {{ translationService.getResinTypeText() }}
        </th>
        <td mat-cell *matCellDef="let r">
          {{ r.resinType || translationService.getNaText() }}
        </td>
      </ng-container>

      <ng-container matColumnDef="resinSource">
        <th mat-header-cell *matHeaderCellDef class="sticky">
          {{ translationService.getSourceTypeText() }}
        </th>
        <td mat-cell *matCellDef="let r">
          {{ r.sourceType || translationService.getNaText() }}
        </td>
      </ng-container>

      <ng-container matColumnDef="weightPerUnitKg">
        <th mat-header-cell *matHeaderCellDef class="sticky">
          {{ translationService.getKgPerUnitText() }}
        </th>
        <td mat-cell *matCellDef="let r">
          {{ r.weightPerUnitKg ?? translationService.getNaText() }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="zebra"
      ></tr>
    </table>
  </div>

  <footer class="actions">
    <button mat-stroked-button color="primary" (click)="close()">
      {{ translationService.getCloseText() }}
    </button>
  </footer>
</div>
